import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { ApplicantsReportsModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-data-model';
import { ApplicantReportsListingModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-grid-model';
import { ApplicantReportsGridMetaModel } from 'common/models/page-models/reports/applicant-reports/applicant-report-grid-meta.model';
import { BranchCategoryGridDataService } from 'common/services/data-services/admin/branch-category/branch-category-grid.service';
import { ApplicantsReportsDataService } from 'common/services/data-services/admin/reports/applicant-reports.service';


@Injectable({
    providedIn: 'root'
})
export class ApplicantReportsWidgetService extends GridWidgetService<ApplicantsReportsModel, ApplicantReportsListingModel> {
    constructor(protected override  ds: ApplicantsReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: BranchCategoryGridDataService, private stateService: stateListDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new ApplicantReportsGridMetaModel().getMetaModel();
        return meta;
    }

     override prepareMetaModel(dataModel: ApplicantReportsListingModel, metaModel: ApplicantReportsGridMetaModel, routeData: WidgetModel): Promise<ApplicantReportsGridMetaModel> {
        return new Promise<ApplicantReportsGridMetaModel>((resolve, reject) => {
            
            // this.batchListService.postData('').then((data) =>{
            //     metaModel.filterMeta.properties.selectedBatch.options = data.detail;
            // });
            this.branchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            resolve(metaModel);
        });
    }

}